
// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class FireworksExplosionParticle extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    /* START-USER-CTR-CODE */
    const emitter = this.scene.add.particles(x, y, 'particles', {
      frame: [ 'particle-spark-white.png','particle-spark-yellow.png'],
      lifespan:500,
      speed: { min:200, max: 500 },
      scale: { start: 0.1, end:1 },
      alpha: { start: 1, end: 0 },
      rotate: { start: 0, end: 10 },
      gravityY: 0,
      
      emitting: false
    });
    emitter.explode(10);

    const emitterStars = this.scene.add.particles(x, y, 'particles', {
      frame: [ 'particle-star-pink.png','particle-star-red.png','particle-star-white.png','particle-star-yellow.png'],
      lifespan:500,
      speed: { min:200, max: 500 },
      scale: { start: 0.1, end:1 },
      alpha: { start: 1, end: 0 },
      rotate: { start: 0, end: 360 },
      gravityY: 0,
      
      emitting: false
    });
    emitterStars.explode(10);

    const fireworksEmitter = this.scene.add.particles(x, y, 'particles', {
      frame: [ 'particle-firework-1.png','particle-firework-2.png'],
      lifespan:1000,
      speed: { min:800, max: 1250 },
      scale: { start: 1, end:0 },
      alpha: { start: 1, end: 0 },
      gravityY: 0.1,
      emitting: false,
      rotate:{
        onEmit: (particle) => {
          return 0
        },
        onUpdate: (particle) => {
          //make the particles face the direction of travel...
          let angle:number = Math.atan2(particle.velocityY, particle.velocityX) * (180/Math.PI) + 90;
          return angle;
        },
      }
    });



    fireworksEmitter.explode(5);

    fireworksEmitter.on('complete', () => {
      this.destroy(true);
    });
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
